import React from 'react';
import { bankInfo } from './BankFeedInfo';
import WestPac from './WestPacFeed';
import ANZFeed from './ANZFeed';
import css from './bfm.css';

const DownloadBankFeedForm = ({ feed, userid, downloadForm, downloadAutoFilledForm }) => {
    if (feed.bankId === 1 || feed.bankId === 31) return <ANZFeed bankId={feed.bankId} userid={userid} /> // For ANZ - AU Feeds
    if (feed.bankId === 17) return <WestPac userid={userid} />

    if (!bankInfo[feed.bankId].form) {
        return (
            <div className={[css.w400, css.fontSmall].join(' ')}>
                <div className={css.dFlex}>
                    <div className={[css.flex1, css.muted].join(' ')}><i className="far fa-file fa-3x text-muted"></i></div> 
                    <div className={css.flex3}><p>{bankInfo[feed.bankId].step1}</p></div>
                </div>
                <div className={css.dFlex}>
                    <div className={css.flex1}></div>
                    <div className={css.flex3}><p>{bankInfo[feed.bankId].step2}</p></div>
                </div>

                <div className={css.dFlex}>
                        <div className={css.flex1}></div>
                        <div className={css.flex3}>
                            <div>
                                <p>{bankInfo[feed.bankId].step3}</p>
                            </div>
                            {(feed.bankId === 1) && <div>
                                <div><hr /></div>
                                <div><strong>Primary ID: {userid}</strong></div>  
                            </div>}
                    </div>
                </div>
            </div>
        );
    }

    return (
            <div className={[css.w400, css.fontSmall].join(' ')}>
                <div className={css.dFlex}>
                    <div className={[css.flex1, css.pt20, css.muted].join(' ')}><i className="far fa-file fa-3x text-muted"></i></div> 
                    <div className={css.flex3}><p>{bankInfo[feed.bankId].step1}{feed.bankId === 4 && <span>We recommend you read this <a rel='noopener noreferrer' target='_blank' href='https://help.reckon.com/article/d3de91651b-commonwealth-bank-filling-out-the-authorisation-form'>Help Article</a> before completing the form</span>}</p></div>
                </div>

                <div className={css.dFlex}>
                    <div className={css.flex1}></div>
                    <div className={[css.flex3, css.pb10].join(' ')}>
                        <a href="#" onClick={()=> downloadAutoFilledForm(feed,bankInfo[feed.bankId].form)}>Download the form now</a>
                    </div>
                </div>

                <div className={css.dFlex}>
                    <div className={[css.flex1, css.pt20, css.muted].join(' ')}><i className="far fa-envelope fa-3x text-muted"></i></div>
                    <div className={css.flex3}><p>{bankInfo[feed.bankId].step2}</p></div>
                </div>

                <div className={css.dFlex}>
                    <div className={[css.flex1, css.pt20, css.muted].join(' ')}><i className="far fa-clock fa-3x text-muted"></i></div>
                    <div className={css.flex3}>
                        <p>{bankInfo[feed.bankId].step3}</p>
                        {(feed.bankId === 18 || feed.bankId === 21) && <p><strong>Note:</strong> You will be completing a St George form for this feed</p>}
                    </div>
                </div>

                {(feed.formUploaded) && <div className={css.dFlex}>
                    <div className={css.flex1}></div>
                    <div className={css.flex3}><a href="#" onClick={() => downloadForm(feed.feedId)}> Download your Filled out form now</a></div>
                </div>}
            </div>

     );
};

export default DownloadBankFeedForm;


// WEBPACK FOOTER //
// ./src/components/FeedManagment/DownloadBankFeedForm.js